export const groupParticipations = (participations) => {
    return participations.reduce((groupedParticipations, row) => {
        if (isParticipationValid(row.columns)) {
            groupedParticipations.validParticipations.push(row);
        }
        else {
            groupedParticipations.invalidParticipations.push(row);
        }
        return groupedParticipations;
    }, { validParticipations: [], invalidParticipations: [] });
};
const isParticipationValid = (columns) => {
    return (columns.positions.length === 1 &&
        columns.status !== 'deniedRosterFull' &&
        columns.status !== 'deniedNotQualified' &&
        columns.accountOigStatus !== 'notVerified');
};
